import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonConfigurationSubscriptionOverview, CommonConfigurationSubscriptionTopics } from "../../CommonComponents/CommonConfigurationSubscriptionViews";
export const ConfigurationSubscriptionsNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.configuration.subscriptions.create,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationSubscriptionOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => {
        return <CommonConfigurationSubscriptionTopics />;
    },
};
